export default {
      id: "ic-nav-pause-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-nav-pause-usage",
      toString: function () {
        return this.url;
      }
    }